import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-go",
  "use": "icon-go-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-go\"><path d=\"M793.1392 544l-198.8096 198.8096a32 32 0 0 0 45.2608 45.2608l249.856-249.856a37.12 37.12 0 0 0 0-52.48l-249.856-249.8048a32 32 0 0 0-45.2608 45.2608l198.8096 198.8096H153.6a32 32 0 1 0 0 64h639.5392z\" fill=\"\" p-id=\"5576\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol